export const myCafateriaBenefitsTableDef = {
  id: "my-cafeteria-benefits-table-def",
  columns: [
    {
      id: "origin",
      label: "MY_CAFETERIA_ORIGIN",
      type: "text",
    },
    {
      id: "benefit",
      type: "text",
      label: "MY_CAFETERIA_BENEFIT",
      //width: "85px",
    },
    {
      id: "months",
      type: "text",
      label: "MY_CAFETERIA_MONTHS",
      align: "right",
    },
    {
      id: "numberOfMonths",
      type: "text",
      label: "MY_CAFETERIA_NUMBER_OF_MONTHS",
      align: "right",
    },
    {
      id: "amount",
      type: "currency",
      label: "MY_CAFETERIA_NETTO",
      align: "right",
    },
    {
      id: "cost",
      type: "currency",
      label: "OC_COST",
      align: "right",
    },
    {
      id: "valueOfBenefit",
      type: "currency",
      label: "MY_CAFETERIA_BRUTTO",
      zeroPadding: true,
      align: "right",
    },
    {
      id: "action",
      type: "editButton",
      //label: "COST",
      align: "right",
    },
  ],
};

export const MyCafateriaBenefitsMobileTableDef = {
  id: "my-cafeteria-benefits-mobile-table-def",
  select: "row",
  columns: [
    {
      id: "benefit",
      type: "text",
      label: "MY_CAFETERIA_BENEFIT",
    },
    {
      id: "months",
      type: "text",
      label: "MY_CAFETERIA_MONTHS",
      align: "right",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myCafateriaArchivedBenefitsTableDef = {
  id: "my-cafeteria-archived-benefits-table-def",
  columns: [
    {
      id: "origin",
      label: "MY_CAFETERIA_ORIGIN",
      type: "text",
    },
    {
      id: "benefit",
      type: "text",
      label: "MY_CAFETERIA_BENEFIT",
      //width: "85px",
    },
    {
      id: "months",
      type: "text",
      label: "MY_CAFETERIA_MONTHS",
      align: "right",
    },
    {
      id: "numberOfMonths",
      type: "text",
      label: "MY_CAFETERIA_NUMBER_OF_MONTHS",
      align: "right",
    },
    {
      id: "amount",
      type: "currency",
      label: "MY_CAFETERIA_NETTO",
      align: "right",
    },
    {
      id: "cost",
      type: "currency",
      label: "OC_COST",
      align: "right",
    },
    {
      id: "valueOfBenefit",
      type: "currency",
      label: "MY_CAFETERIA_BRUTTO",
      zeroPadding: true,
      align: "right",
    },
    {
      id: "action",
      type: "copyButton",
      //label: "COST",
      align: "right",
    },
  ],
};

export const MyCafeteriaArchivedBenefitsMobileTableDef = {
  id: "my-cafeteria-archived-benefits-mobile-table-def",
  select: "row",
  columns: [
    {
      id: "benefit",
      type: "text",
      label: "MY_CAFETERIA_BENEFIT",
    },
    {
      id: "months",
      type: "text",
      label: "MY_CAFETERIA_MONTHS",
      align: "right",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myCafateriaVbkApplicationsTableDef = {
  id: "my-cafeteria-vbk-applications-table-def",
  columns: [
    {
      id: "benefit",
      type: "text",
      label: "MY_CAFETERIA_BENEFIT",
      //width: "85px",
    },
    {
      id: "months",
      type: "text",
      label: "MY_CAFETERIA_MONTHS",
      align: "right",
    },
    {
      id: "numberOfMonths",
      type: "text",
      label: "MY_CAFETERIA_NUMBER_OF_MONTHS",
      align: "right",
    },
    {
      id: "amount",
      type: "currency",
      label: "OC_AMOUNT",
      align: "right",
    },
    {
      id: "valueOfBenefit",
      type: "currency",
      label: "MY_CAFETERIA_VALUE_OF_BENEFIT",
      zeroPadding: true,
      align: "right",
    },
    {
      id: "cost",
      type: "currency",
      label: "OC_COST",
      align: "right",
    },
  ],
};
